import urljoin from 'url-join';
export function sanitizeRedirectUrlForLocalDevelopment(redirectUrl) {
    if (redirectUrl.startsWith('http://localhost') || redirectUrl.startsWith('https://localhost')) {
        // Check on hostname only not port
        return '';
    }
    return redirectUrl;
}
export function getLoginUrl(authServiceOptions, registeredFags, language, countryCode, prompt, redirectUrl) {
    const redirectAfterLogin = sanitizeRedirectUrlForLocalDevelopment(redirectUrl || authServiceOptions.defaultLoginRedirectUrl);
    const loginUrl = [
        authServiceOptions.authProxyUrl,
        '/login',
        `?fag=${encodeURIComponent(registeredFags.join(','))}&redirectUrl=${encodeURIComponent(redirectAfterLogin)}`,
    ];
    if (prompt) {
        loginUrl.push(...registeredFags.map((fag) => `&prompt-${fag}=${encodeURIComponent(prompt)}`));
    }
    loginUrl.push(`&ui_locales=${language.toLowerCase()}-${countryCode.toUpperCase()}`);
    loginUrl.push(`&ext-country_of_residence=${countryCode.toUpperCase()}`);
    const fagScopesQuery = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const fag of registeredFags) {
        const fagScopes = authServiceOptions.fagScopeMappings.get(fag);
        if (fagScopes && fagScopes.length > 0) {
            fagScopesQuery.push(`scope-${fag}=${encodeURIComponent(fagScopes.join(','))}`);
        }
    }
    if (fagScopesQuery.length > 0) {
        loginUrl.push(`&${fagScopesQuery.join('&')}`);
    }
    return urljoin(loginUrl);
}
export function getAuthenticatedUrl(authServiceOptions, fag) {
    const authenticateUrl = [authServiceOptions.authProxyUrl, `/${fag}/authenticated`];
    const fagScopes = authServiceOptions.fagScopeMappings.get(fag);
    if (fagScopes && fagScopes.length > 0) {
        authenticateUrl.push(`?scope=${encodeURIComponent(fagScopes.join(','))}`);
    }
    return urljoin(authenticateUrl);
}
export function getUserUrl(authServiceOptions, fag) {
    const userUrl = [authServiceOptions.authProxyUrl, `/${fag}/user`];
    return urljoin(userUrl);
}
export function getLogoutUrl(authServiceOptions, defaultOrigin, csrfToken, redirectUrl) {
    const completeRedirectUrl = redirectUrl
        ? new URL(redirectUrl, defaultOrigin).toString()
        : undefined;
    const redirectAfterLogout = sanitizeRedirectUrlForLocalDevelopment(completeRedirectUrl || authServiceOptions.defaultLoginRedirectUrl);
    const logoutUrl = [
        authServiceOptions.authProxyUrl,
        '/logout',
        `?redirectUrl=${encodeURIComponent(redirectAfterLogout)}&_csrf=${csrfToken}`,
    ];
    return urljoin(logoutUrl);
}
export function getProxyUrl(authServiceOptions, fag, resourceHostId, path) {
    const proxyUrlParts = [authServiceOptions.authProxyUrl];
    proxyUrlParts.push(`${fag}/proxy`);
    if (path) {
        proxyUrlParts.push(path);
    }
    if (resourceHostId) {
        proxyUrlParts.push(`?resourceHost=${resourceHostId}`);
    }
    return urljoin(proxyUrlParts);
}
export function getFormUrl(authServiceOptions, path) {
    var _a;
    const proxyUrlParts = [authServiceOptions.authProxyUrl];
    const formResourceHostId = (_a = authServiceOptions.authProxyFormMyaudiResourceHostId) !== null && _a !== void 0 ? _a : 'form-myaudi';
    proxyUrlParts.push(formResourceHostId);
    if (path) {
        proxyUrlParts.push(path);
    }
    // Remove trailing slashes
    return urljoin(proxyUrlParts).replace(/\/$/, '');
}
//# sourceMappingURL=AuthProxyUrlBuilder.js.map